
var swiperSocial = new Swiper(".socialmedia__post", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  breakpoints: {
    550: {
      slidesPerView: 2.2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3.3,
      spaceBetween: 10,
    },
    972: {
      slidesPerView: 4.4,
      spaceBetween: 20,
    },
  },
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});


var playButton=document.querySelectorAll(".play__button");
var videoMain=document.querySelectorAll(".social__content--video video");


playButton.forEach(function(ele){



ele.addEventListener("click", function(){
  var parentDiv = ele.closest(".socialpost--main");
  var innerVideo=parentDiv.querySelector(".social__content--video video");
  var videoPoster=parentDiv.querySelector('.image__poster')
  innerVideo.play();
  innerVideo.controls = true;
  videoPoster.style.display="none";
})
})

videoMain.forEach(function(ele){
  videoMain.addEventListener("pause",function(){
    var videoParent = ele.closest(".socialpost--main");
    var videoControls=videoParent.querySelector(".social__content--video video");
    var videoPoster=videoControls.querySelector('.image__poster');
    videoControls.controls = false;
    videoPoster.style.display="block";
})
})

